module.exports = __webpack_public_path__ + "img/ic_16_arrow_down.3fcbc0d2.svg";